export class OrderResponse {
  public question: string;
  public response: string;

  constructor(question: string, response: string) {
    this.question = question;
    this.response = response;
  }
}
